import { render, staticRenderFns } from "./SnsTeamSection.vue?vue&type=template&id=b1aef932&scoped=true"
import script from "./SnsTeamSection.vue?vue&type=script&lang=ts"
export * from "./SnsTeamSection.vue?vue&type=script&lang=ts"
import style0 from "./SnsTeamSection.vue?vue&type=style&index=0&id=b1aef932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1aef932",
  null
  
)

export default component.exports